module.exports = __webpack_public_path__ + "media/shared/assets/img/placeholders/placeholder_1x1-54b7883fa594a6a522ffee83cea69b70.jpg";